const Warning = () => (
  <svg viewBox='0 0 20 20'>
    <path d='m10.722 2.5 7.938 13.75a.834.834 0 0 1-.721 1.25H2.062a.834.834 0 0 1-.722-1.25L9.278 2.5a.833.833 0 0 1 1.444 0ZM3.505 15.833h12.99L10 4.583l-6.495 11.25Zm5.662-2.5h1.667V15H9.167v-1.667Zm0-5.833h1.667v4.166H9.167V7.5Z' />
  </svg>
)

export { Warning }
